import { useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { MdWarning } from "react-icons/md";
import { Button } from "../buttons/Button";
import { Motion } from "../motion";
import { useMediaQuery } from "hooks/useMediaQuery";

const MobileDeviceDetector: React.FC<{ inproject?: boolean }> = ({ inproject = false }) => {
  const isMobile = useMediaQuery("(max-width: 767px)");
  const [show, setShow] = useState(true);

  if (!isMobile || !show) return null;

  return (
    <div className={inproject && isMobile ? "-ml-6 mr-7" : ""}>
      <Motion
        className="flex justify-center h-fit w-full mt-[2em] p-[1em]"
        type={"div"}
        property="y"
      >
        <div className="flex flex-row gap-[5px] w-11/12 card-border bg-muted/60">
          <div className="p-[1em] w-fit">
            <MdWarning className="text-warning text-3xl" />
          </div>

          <div className="flex flex-col py-2">
            <span className="text-regular-1 text-left opacity-60">
              Our web app is optimized for desktop use. For the best experience, please switch to a
              desktop device
            </span>
          </div>
          <div>
            <Button
              type="button"
              color="gray"
              size="icon"
              className="h-8 w-8 [&_svg]:h-5 [&_svg]:w-5"
              onClick={() => {
                setShow(false);
              }}
              aria-label="Close warning"
            >
              <AiOutlineClose />
            </Button>
          </div>
        </div>
      </Motion>
    </div>
  );
};

export default MobileDeviceDetector;
